import { Stack, useTheme } from "@mui/material";
import * as XLSX from "xlsx";
import { AddIcon, DownloadIcon } from "~components/Icons";
import { Headline, PollQuestion, NoPolls } from "~components/atoms";
import { PollCreation } from "~components/molecules";
import { usePollContext } from "~contexts/Poll";
import { useStreamContext } from "~contexts/Stream";
import { useToastNotificationContext } from "~contexts/ToastNotification";
import BrandSelector from "~components/atoms/BrandSelector";
import { Box, Typography } from "@mui/material";


const Poll = () => {
  const theme: any = useTheme();
  const { currentStream } = useStreamContext();
  const { polls, setIsEditing, isEditing } = usePollContext();
  const { setToastData } = useToastNotificationContext();

  const onDownloadPollResults = () => {
    if (!polls.length) {
      setToastData(
        {
          title: "nenhum resultado",
          text: "não há enquetes para exportar",
        },
        "error"
      );
      return;
    }

    const headers = [
      "id enquete",
      "pergunta",
      "status",
      "id opção",
      "opção",
      "votos",
      "percentual",
      "imagem",
    ];

    const rows = polls.flatMap((poll) => {
      const totalVotes = poll.options.reduce((acc, option) => acc + (option.count || 0), 0);
      return poll.options.map((option) => {
        const percentage =
          option.porcentQuestion !== null && option.porcentQuestion !== undefined
            ? option.porcentQuestion
            : totalVotes > 0
              ? Math.floor(((option.count || 0) * 100) / totalVotes)
              : 0;

        return [
          poll.id,
          poll.question,
          poll.active ? "ativa" : "finalizada",
          option.id,
          option.text,
          option.count || 0,
          `${percentage}%`,
          option.image || "",
        ];
      });
    });

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resultados");

    const streamName = currentStream?.name || "stream";
    XLSX.writeFile(workbook, `somalive-${streamName}-resultados-enquete.xlsx`);
  };

  const PRIMARY_BUTTON = {
    icon: <DownloadIcon />,
    text: "download dos resultados",
    onAction: onDownloadPollResults,
  };

  const SECONDARY_BUTTON = {
    icon: <AddIcon />,
    text: "adicionar enquete",
    onAction: () => setIsEditing(true),
  };

  // Se não há brand selecionada, mostrar mensagem
  if (!currentStream) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          minHeight: "60vh",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.grey[0],
            fontSize: "30px !important",
          }}
          variant="h1"
        >
          bem-vindo ao ambiente AzzasLive
        </Typography>
        <Typography
          sx={{
            color: theme.palette.grey[600],
            fontSize: "15px",
            marginBottom: "24px",
          }}
        >
          comece a configurar sua live pelo menu ao lado após selecionar uma marca
        </Typography>
        <BrandSelector invertColors={true} />
      </Box>
    );
  }

  return (
    <Stack>
      <Headline
        title="enquete"
        primaryButton={PRIMARY_BUTTON}
        secondaryButton={SECONDARY_BUTTON}
      />

      {isEditing && <PollCreation />}

      {!!polls.length && !isEditing && <PollQuestion />}

      {!polls.length && !isEditing && <NoPolls />}
    </Stack>
  );
};

export default Poll;
